module.exports = ($uibModal) ->
  return {
    scope:
      project: '=project'
      type: '@type'
      showDownloadButton: '='
      forExternalSystem: '='
    link: ($scope, element, attr) ->
      element.on 'click', ->
        exportModal = $uibModal.open
          template: require("./export-modal.html")
          controller: require("./ExportModalController")
          size: "sm"
          resolve:
            type: () ->
              $scope.type
            projectId: () ->
              $scope.project
            showDownloadButton: () ->
              $scope.showDownloadButton
            forExternalSystem: () ->
              $scope.forExternalSystem
        return

  }
